import React, { PropsWithChildren, useMemo } from 'react';
import '../nestedDraggable.style.scss';
import { DroppableHeaderContextType } from './droppableHeaderV2.models';
import { DroppableHeaderContext } from './droppableHeaderV2.hook';
import { DroppableHeaderTitleAndOptions } from './components/droppableHeaderTitleAndOptions';
import { DroppableHeaderOptionsSeparator } from './components/droppableHeaderOptionsSeparator';
import { DroppableHeaderOptionsDetailsOrEditButton } from './components/droppableHeaderOptionsDetailsOrEditButton';
import { DroppableHeaderOptionsSwitchPhotoButton } from './components/droppableHeaderOptionsSwitchPhotoButton';
import {
  DroppableHeaderOptionsDeleteButton,
  DroppableHeaderOptionsDeleteWithPopoverButton
} from './components/droppableHeaderDeleteButtons';
import { DroppableHeaderActionsSlotContainer } from './components/droppableHeaderActionsSlotContainer';
import { DroppableHeaderActionButton } from './components/droppableHeaderActionButton';
import { DroppableHeaderActionsCollapseAllButton } from './components/droppableHeaderActionsCollapseAllButton';

type DroppableHeaderV2Props = PropsWithChildren<DroppableHeaderContextType>;

function DroppableHeaderV2({ color, children, isCanonical, collapseAll }: DroppableHeaderV2Props) {
  const contextValues = useMemo(() => ({ color, isCanonical, collapseAll }), [color, isCanonical, collapseAll]);
  return (
    <DroppableHeaderContext.Provider value={contextValues}>
      <div
        className={
          {
            GREY: 'drag-header--grey',
            GREEN: 'drag-header--green',
            BLUE: 'drag-header--blue',
            LIGHT_GREY: 'drag-header--light-grey',
            default: 'drag-header'
          }[color]
        }>
        <div className='flex-space-between flex-baseline'>{children}</div>
      </div>
    </DroppableHeaderContext.Provider>
  );
}

DroppableHeaderV2.Options = DroppableHeaderTitleAndOptions;
DroppableHeaderV2.OptionsSeparator = DroppableHeaderOptionsSeparator;
DroppableHeaderV2.OptionsDetailsOrEditButton = DroppableHeaderOptionsDetailsOrEditButton;
DroppableHeaderV2.OptionsSwitchPhotoButton = DroppableHeaderOptionsSwitchPhotoButton;
DroppableHeaderV2.OptionsDeleteButton = DroppableHeaderOptionsDeleteButton;
DroppableHeaderV2.OptionsDeleteWithPopoverButton = DroppableHeaderOptionsDeleteWithPopoverButton;
DroppableHeaderV2.ActionsSlotContainer = DroppableHeaderActionsSlotContainer;
DroppableHeaderV2.ActionButton = DroppableHeaderActionButton;
DroppableHeaderV2.ActionCollapseAllButton = DroppableHeaderActionsCollapseAllButton;

export { DroppableHeaderV2 };
